<p class="text-end p-3">
    <span mat-button mat-dialog-close>
        <svg xmlns="http://www.w3.org/2000/svg" width="13.998" height="13.998" viewBox="0 0 13.998 13.998">
            <path id="close-btn"
                d="M8.177-11.911,6.768-13.32l-5.59,5.59-5.59-5.59L-5.82-11.911l5.59,5.59L-5.82-.732-4.411.677l5.59-5.59L6.768.677,8.177-.732l-5.59-5.59Z"
                transform="translate(5.82 13.32)" fill="#bbb" />
        </svg>
    </span>
</p>
<mat-dialog-content>
    <div class="suspend">
        <ng-container *ngIf="data?.user.is_active; else elseTemplate">
            <img src="assets/images/suspend.svg" alt="">
            <h4 class="title">Suspend bidder's account?</h4>
            <div class="info-badge">
                <div class="badge-img rounded-circle">
                    <img *ngIf="data.user.image" [src]="data.user.image" (error)='data.user.image = ""'>
                    <span *ngIf="!data.user.image">
                        {{data.user.firstname +" "+ data.user.lastname | shortName }}</span>
                </div>
                <div class="badge-text">
                    <p>{{data.user.firstname +" "+ data.user.lastname |titlecase}}</p>
                </div>
            </div>
            <div class="hint">
                This user will not be able to join any auction until you unsuspend his/her account.
            </div>

            <form (ngSubmit)="OnSuspend()" [formGroup]="suspendForm">

                <!-- <div class="inputs-form-section"> -->
                <mat-form-field appearance="outline" class="form-group">
                    <mat-label>Reason of suspension</mat-label>
                    <textarea formControlName="reason_suspend" matInput maxlength="50" minlength="5" required
                        rows="6"></textarea>
                    <mat-error *ngIf="suspendForm.controls['reason_suspend'].hasError('required')">
                        {{'Auctions.Field is Required'|translate}}
                    </mat-error>
                    <mat-error *ngIf="suspendForm.controls['reason_suspend'].hasError('minlength')">
                        {{'validations.minlength' | translate}} 5
                    </mat-error>
                </mat-form-field>
                <!-- </div> -->


                <div class="actions group_btn">
                    <button mat-button mat-dialog-close class="btnLight_fill" *ngIf="!loading">No, Keep
                        it</button>
                    <button mat-button class="btn_fill" type="submit" [appLoading]="loading">Yes,
                        suspend
                        account</button>
                </div>


            </form>

        </ng-container>
        <ng-template #elseTemplate>
            <img src="assets/images/Unsuspend.svg" alt="">
            <h4 class="title">Unsuspend bidder's account?</h4>
            <div class="info-badge">
                <div class="badge-img rounded-circle">
                    <img *ngIf="data.user.image" [src]="data.user.image" (error)='data.user.image = ""'>
                    <span *ngIf="!data.user.image">
                        {{data.user.firstname +" "+ data.user.lastname | shortName }}</span>
                </div>
                <div class="badge-text">
                    <p>{{data.user.firstname +" "+ data.user.lastname |titlecase}}</p>
                </div>
            </div>
            <div class="hint">
                Once the suspension has been lifted, this user will be eligible to join the auctions. </div>


            <div class="actions group_btn">
                <button mat-button mat-dialog-close class="btnLight_fill" *ngIf="!loading">No, Cancel</button>
                <button mat-button class="btn_fill" type="submit" (click)="OnUnsuspend()" [appLoading]="loading">Yes,
                    Unsuspend Account</button>
            </div>


        </ng-template>
    </div>
</mat-dialog-content>


<!-- </div> -->